<!--
 * @Description: 教职工详情 工人技术等级及职务
 * @Author: 张天伟
 * @Date: 2023-03-08 17:08:26
 * @LastEditors: PF
 * @LastEditTime: 2025-02-13 14:04:48
-->

<template>
  <div>
    <el-descriptions class="descript-box" v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="工人技术等级" label-align="right" align="left" width="120px" span="2">{{item.grjsdjbt}}</el-descriptions-item>
      <el-descriptions-item label="工人技术职务" label-align="right" align="left" width="120px" span="2">{{item.grjszwbt}}</el-descriptions-item>
      <el-descriptions-item label="工人工种" label-align="right" align="left" width="120px" span="2">{{item.grgzbt}}</el-descriptions-item>
      <el-descriptions-item label="等级发证机关" label-align="right" align="left" width="120px" span="2">{{item.djfzjg}}</el-descriptions-item>
      <el-descriptions-item label="等级评定日期" label-align="right" align="left" width="120px" span="4">{{item.djpdrq}}</el-descriptions-item>
      <el-descriptions-item label="" label-align="right" align="left" span="4"></el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({
  row: { type: Object, required: false }
})
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = {
        url: '/api/v2/renliziyuan/jiaozhigonggongrenjishudengjiyuzhiwu/list',
        data: { id: props.row.id, order: 'gh', sort: 'asc' }
      }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
